




















import { SubscriptionFilterGroup } from "../../../types/subscriptions/subscriptionFilterGroup";
import { AppComponent } from "@/App.vue";
export default AppComponent.extend({
    name: "SubscriptionsFilter",
    props: {
        groups: Array as () => SubscriptionFilterGroup[],
        model: Array as () => SubscriptionFilterGroup[],
        panelName: String
    },
    data: () => {
        return {
            selectedGroups: [] as SubscriptionFilterGroup[]
        };
    },
    model: {
        prop: "model",
        event: "change"
    },
    watch: {
        selectedGroups(newValue: SubscriptionFilterGroup[]) {
            this.$emit("change", newValue);
        },
        model: {
            handler(newValue: SubscriptionFilterGroup[]) {
                if (newValue) this.selectedGroups = newValue;
            },
            immediate: true
        }
    },
    methods: {
        init(): void {
            if (this.model) this.selectedGroups = this.model;
        }
    }
});
